import './transit-order-summary.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { Mask } from '@core/app/scripts/services/mask';

/*
 * Component responsible for /transit-order-summary route.
 */
angular
  .module('posApp')
  .directive(
    'transitOrderSummary',
    (
      broadcaster: Broadcaster,
      displayMessage: DisplayMessage,
      legacyPrint,
      locationManager: LocationManager,
      mask: Mask,
      navigateTo: NavigateTo,
      pos,
      settingsManager,
      salesCalculations,
      transit,
      transitOrderSummary,
      translate,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./transit-order-summary.html').default,

      link: function ($scope: any) {
        const $translate = translate;

        $scope.pos = pos;

        $scope.showExtraArticleInfo =
          settingsManager.settings.pos?.extendedReceipt;

        $scope.transaction = {};
        $scope.openEmailPopup = false;
        let fromPage = '';

        // ngOnInit
        $scope.showExtraArticleInfo = false;
        $scope.transitEmail = '';
        $scope.transaction = transitOrderSummary.transaction;
        fromPage = transitOrderSummary.fromPage;
        salesCalculations.preCalc($scope.transaction);

        $scope.toggleEmailPopup = () => {
          if (!settingsManager.settings.email.active) {
            displayMessage.message({
              message: $translate.instant('MissingEmailingModule'),
              type: 'info',
            });
            return;
          }

          broadcaster.send('setFocus', ['transitEmail', true]);
          $scope.openEmailPopup = $scope.openEmailPopup ? false : true;
        };

        /*
         * Send the receipt re-print as an email
         */
        $scope.emailReceipt = (transitEmail) => {
          $scope.openEmailPopup = false;

          if (transitEmail) {
            displayMessage.showLoading();
            transit.email($scope.transaction._id, [transitEmail]).then(
              () => {
                mask.hide();
              },
              () => {
                mask.hide();
              },
            );
          } else {
            displayMessage.message($translate.instant('MissingEmailAddress'));
          }
        };

        // print the current transaction
        // TODO cover with tests
        $scope.printReceipt = () => {
          displayMessage.showLoading();

          legacyPrint
            .transitOrder({
              transactions: $scope.transaction,
              config: pos.config,
              send: true,
            })
            .then(angular.noop, () => {
              displayMessage.message($translate.instant('PrintingNotPossible'));
            });

          $scope.navigateBack();
        };

        $scope.navigateBack = () => {
          mask.hide();
          navigateTo(fromPage);
        };

        $scope.getPeerWarehouseName = (warehouseId) => {
          let warehouse;
          if (locationManager.all) {
            warehouse = _.find(locationManager.all, { wh: warehouseId });
          }
          return angular.isObject(warehouse) ? warehouse.name : '';
        };

        $scope.getTotalQty = () => {
          return $scope.transaction && $scope.transaction.receipt
            ? $scope.transaction.receipt
                .map((item) => item.qty)
                .reduce((previousValue, currentValue) => {
                  return previousValue + currentValue;
                })
            : 0;
        };
      },
    }),
  );
